.page { flex: 1; overflow-y: auto; padding-bottom: 40px; background: var(--bg); }

.emptyOk {
  max-width: 560px;
  margin: 0 32px;
  padding: 24px 28px;
  font-size: 14px;
  color: var(--text2);
  background: var(--ok-bg);
  border: 1px solid color-mix(in srgb, var(--ok) 30%, transparent);
  border-radius: var(--r-lg);
}

.emptyOk p { margin: 6px 0 0; }
.emptyTitle { font-size: 17px; font-weight: 600; color: var(--ok); }

.tabs {
  display: flex;
  gap: 4px;
  margin: 0 32px 16px;
  overflow-x: auto;
  border-bottom: 1px solid var(--border);
  scrollbar-width: none;
}

.tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 14px;
  margin-bottom: -1px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text2);
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  cursor: pointer;
}

.tab:hover { color: var(--text); }
.tabActive, .tabActive:hover { color: var(--text); border-bottom-color: var(--blue); }

.count {
  padding: 0 7px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: var(--text2);
  background: var(--border);
  border-radius: var(--r-pill);
}

.countErr { color: var(--err); background: var(--err-bg); }

.none { margin: 0 32px; font-size: 14px; color: var(--text2); }

.groups {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(460px, 1fr));
  gap: 14px;
  margin: 0 32px;
}

.group {
  overflow-x: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.groupHeader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  box-shadow: inset 3px 0 0 var(--err);
}

.serial { font-family: var(--mono); font-size: 14px; font-weight: 600; color: var(--text); }
.groupCount { font-size: 13px; color: var(--text2); }

.table { width: 100%; font-size: 13.5px; border-collapse: collapse; }

.table td {
  padding: 10px 16px;
  color: var(--text);
  border-bottom: 1px solid var(--border);
}

.table tr:last-child td { border-bottom: none; }
.table tbody tr { cursor: pointer; }
.table tbody tr:hover td,
.table tbody tr:focus-visible td { background: var(--table-hover); }
.table tbody tr:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; }

.object { white-space: nowrap; }
.mono { font-family: var(--mono); font-size: 12.5px; white-space: nowrap; }
.muted { color: var(--text2); }

@media (max-width: 699px) {
  .emptyOk, .tabs, .none, .groups { margin-left: 16px; margin-right: 16px; }
  .groups { grid-template-columns: 1fr; }
}
